export default __webpack_public_path__ + "static/media/logo_4.8740c8e4.png";